import * as types from '../actions/actionType';

const initialState = {
    apiLoading: {
    },
};

export const dashBoardReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_OTA_INSIGHTS_BY_RANGE:
            return {
                ...state,
                otaInsights: {
                    date: action.date,
                },
                apiLoading: {
                    ...state.apiLoading,
                    isOtaInsightsLoading: true,
                },
            };
        case types.GET_OTA_INSIGHTS_BY_RANGE_SUCCESS:
            return {
                ...state,
                otaInsights: {
                    ...state.otaInsights,
                    payload: action.payload,
                },
                apiLoading: {
                    ...state.apiLoading,
                    isOtaInsightsLoading: false,
                },
            };
        case types.GET_EVENTS_BY_RANGE:
            return {
                ...state,
                events: {
                    startDate: action.startDate,
                    endDate: action.endDate,
                },
                apiLoading: {
                    ...state.apiLoading,
                    isEventsLoading: true,
                },
            };
        case types.GET_EVENTS_BY_RANGE_SUCCESS:
            return {
                ...state,
                events: {
                    ...state.events,
                    payload: action.payload,
                },
                apiLoading: {
                    ...state.apiLoading,
                    isEventsLoading: false,
                },
            };
        case types.GET_OTA_INSIGHTS_EXPORT:
            return {
                ...state,
                otaInsights: {
                    date: action.date,
                },
                apiLoading: {
                    ...state.apiLoading,
                    isOtaInsightsLoading: true,
                },
            };
        case types.GET_OTA_INSIGHTS_EXPORT_SUCCESS:
            return {
                ...state,
                otaInsights: {
                    ...state.otaInsights,
                    payload: action.payload,
                },
                apiLoading: {
                    ...state.apiLoading,
                    isOtaInsightsLoading: false,
                },
            };
        default:
            return state;
    }
};

export default dashBoardReducer;
